export default "__VITE_ASSET__BqOSm_hJ__"